/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
/* PDP material label — swaps text/tooltip per variant, tap-toggle tooltip on touch.
   Markup + data: snippets/desk_pdp-material-label.liquid
   Variant signal: `desk:variant-change` (variantId) from desk_pdp-configurator-script.js → getVariant() */
$(function () {
  var $label = $('[data-material-label]');
  if (!$label.length) return;

  var $pill = $label.find('[data-material-label-trigger]');
  var $text = $label.find('[data-material-label-text]');
  var $tooltip = $label.find('[data-material-label-tooltip]');

  var map = {};
  try {
    map = JSON.parse($('[data-material-label-map]').first().text() || '{}');
  } catch (e) {
    map = {};
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  var $tip = $label.find('.material-label__tooltip');
  var EDGE = 16; // min gap to the screen edge

  // Keeps the tooltip inside the viewport: CSS sets the default `left`,
  // here it's shifted by the amount it overflows the right/left edge.
  function clampTooltip() {
    var tip = $tip[0];
    if (!tip) return;
    tip.style.left = '';
    if (tip.offsetParent === null) return; // not visible

    var rect = tip.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var shift = 0;

    if (rect.right > vw - EDGE) shift = (vw - EDGE) - rect.right;
    if (rect.left + shift < EDGE) shift = EDGE - rect.left;

    if (shift !== 0) tip.style.left = (tip.offsetLeft + shift) + 'px';
  }

  function closeTooltip() {
    $pill.removeClass('is-open').attr('aria-expanded', 'false');
    if ($tip[0]) $tip[0].style.left = '';
  }

  // Liquid map covers only the first 250 variants (product.variants limit);
  // the rest come from the Storefront-fetched inputs (desk_config_fetchAllVariants.liquid).
  function getData(variantId) {
    var id = String(variantId);
    if (map[id] && map[id].text) return map[id];
    var $input = $('.pp_variant_config[data-id="' + id + '"]').first();
    if ($input.length && $input.attr('data-ml-text')) {
      return { text: $input.attr('data-ml-text'), tooltip: $input.attr('data-ml-tooltip') || '' };
    }
    return map[id] || null;
  }

  function render(variantId) {
    var data = getData(variantId);
    closeTooltip();

    if (!data || !data.text) {
      $label.addClass('hided');
      return;
    }

    $text.text(data.text);
    $tooltip.html(escapeHtml(data.tooltip || '').replace(/\r?\n/g, '<br>'));
    $pill.toggleClass('material-label__pill--no-tooltip', !data.tooltip);
    $label.removeClass('hided');
  }

  $(document).on('desk:variant-change', function (e, variantId) {
    if (variantId) render(variantId);
  });

  // Tap / click toggle (mobile; desktop also opens on hover via .desk_tooltip-box-outer)
  $pill.on('click', function (e) {
    if ($pill.hasClass('material-label__pill--no-tooltip')) return;
    if ($(e.target).closest('.material-label__tooltip').length) return;
    e.stopPropagation();
    var open = !$pill.hasClass('is-open');
    $pill.toggleClass('is-open', open).attr('aria-expanded', open ? 'true' : 'false');
    if (open) clampTooltip();
  });

  // desktop hover / keyboard focus (tooltip shown by CSS)
  $pill.on('mouseenter focusin', function () {
    window.requestAnimationFrame(clampTooltip);
  });

  // close on real width change only (mobile scroll resizes height via the address bar)
  var lastWidth = window.innerWidth;
  $(window).on('resize orientationchange', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    closeTooltip();
  });

  $pill.on('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $pill.trigger('click');
    } else if (e.key === 'Escape') {
      closeTooltip();
      $pill.trigger('blur');
    }
  });

  $(document).on('click touchstart', function (e) {
    if (!$(e.target).closest('[data-material-label]').length) closeTooltip();
  });
});